/* eslint-disable max-lines */
import { fetchCohortUsersSeats } from 'actions';
import LoadingIndicator from 'components/LoadingIndicator';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getFetchUsersSeatsLoading, getUsersSeats } from 'selectors/users';
import { useSelector } from 'store';
import { UUID } from 'types';

type ComponentProps = {
  cohortId: UUID;
};

const SeatsTable: React.FC<ComponentProps> = ({ cohortId }) => {
  const dispatch = useDispatch();

  const userSeats = useSelector(getUsersSeats);
  const seatsLoading = useSelector(getFetchUsersSeatsLoading);

  const remainingInsight =
    userSeats.insight_total - userSeats.insight > 0
      ? userSeats.insight_total - userSeats.insight
      : 0;
  const remainingPrevent =
    userSeats.prevent_total - userSeats.prevent > 0
      ? userSeats.prevent_total - userSeats.prevent
      : 0;

  useEffect(() => {
    dispatch(fetchCohortUsersSeats({ cohortId }));
  }, [dispatch, cohortId]);

  return (
    <div className="mt-4 flex flex-col items-end justify-between text-body">
      <div className="mb-0.5 flex flex-row items-center text-litlingo-gray-5 font-bold">
        <span className="w-18 text-center">Total</span>
        <span className="w-25 text-center">Remaining</span>
      </div>

      <div className="flex flex-row">
        <div className="mr-2.5 h-16 flex flex-col justify-around items-end text-litlingo-gray-5 font-bold">
          <span className="">Insight</span>
          <span className="whitespace-no-wrap truncate">Prevent</span>
        </div>

        {seatsLoading ? (
          <div className="w-43 flex justify-center items-center border border-litlingo-gray-3 rounded">
            <LoadingIndicator size="10" />
          </div>
        ) : (
          <>
            <div className="flex flex-col items-center text-litlingo-gray-5 font-bold">
              <div className="h-8 w-18 px-2.5 py-1.5 items-center text-center border-l border-t border-litlingo-gray-3 rounded-tl focus:outline-none">
                {userSeats.insight_total || 0}
              </div>
              <div className="h-8 w-18 px-2.5 py-1.5 items-center text-center border-l border-b border-t border-litlingo-gray-3 rounded-bl focus:outline-none">
                {userSeats.prevent_total || 0}
              </div>
            </div>
            <div className="flex flex-col items-center text-litlingo-gray-5 font-bold">
              <div
                className={`h-8 w-25 px-2.5 py-1.5 items-center text-center border-r border-l border-t border-litlingo-gray-3 rounded-tr focus:outline-none ${
                  remainingInsight <= 0 ? 'text-litlingo-alert' : ''
                }`}
              >
                {remainingInsight}
              </div>
              <div
                className={`h-8 w-25 px-2.5 py-1.5 items-center text-center border border-litlingo-gray-3 rounded-br focus:outline-none ${
                  remainingPrevent <= 0 ? 'text-litlingo-alert' : ''
                }`}
              >
                {remainingPrevent}
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default SeatsTable;
